// LanguageSwitcherIcon.js
import React, { useEffect, useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [language, setLanguage] = useState("fr");
  const lang = localStorage.getItem("language");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
    setLanguage(language);
    handleMenuClose();
  };

  return (
    <>
      <Button
        color="success"
        onClick={handleMenuOpen}
        startIcon={<LanguageIcon />}
        sx={{
          backgroundColor: "green",
          color: "white",
          "&:hover": {
            backgroundColor: "green",
          },
        }}
      >
        {<span>{lang ? lang.toUpperCase() : "FR"}</span>}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => changeLanguage("fr")}>French</MenuItem>
        <MenuItem onClick={() => changeLanguage("en")}>English</MenuItem>
        {/* Add more MenuItems for additional languages */}
      </Menu>
    </>
  );
}

export default LanguageSwitcher;
